const mergeColumn = (columns, columnUpdated) => {
  try {
    // Handle column reordering (from onColumnOrderChange)
    if (columnUpdated.oldIndex !== undefined && columnUpdated.targetIndex !== undefined) {
      // Create a copy and reorder columns
      const reorderedColumns = [...columns];
      const [movedColumn] = reorderedColumns.splice(columnUpdated.oldIndex, 1);
      reorderedColumns.splice(columnUpdated.targetIndex, 0, movedColumn);
      return reorderedColumns;
    }

    // Handle column resize and visibility changes
    let updatedColumns = columns.map(c => {
      if (c.field === columnUpdated.colDef.field) {
        return {
          ...c,
          width: columnUpdated.colDef.width !== undefined ? columnUpdated.colDef.width : c.width ?? 130,
          hide: columnUpdated.colDef.hide !== undefined ? columnUpdated.colDef.hide : c.hide ?? false
        };
      }
      return c;
    });

    return updatedColumns;
  } catch (e) {
    return columns;
  }
};

export const getDataGridColumns = (dataGridId, defaultColumns) => {
  try {
    var userColumns = JSON.parse(localStorage.getItem(dataGridId));
    if (!userColumns || userColumns.length === 0) {
      return defaultColumns;
    }
    
    // Use saved column order, but ensure any new default columns are added
    const savedFieldSet = new Set(userColumns.map(c => c.field));
    const newDefaultColumns = defaultColumns.filter(c => !savedFieldSet.has(c.field));
    
    // Merge: use saved columns in their saved order, then append any new default columns
    const columns = userColumns.map((userCol) => {
      const defaultCol = defaultColumns.find((d) => d.field === userCol.field);
      return defaultCol ? { ...defaultCol, ...userCol } : userCol;
    }).concat(newDefaultColumns);
    
    // Save the merged columns back to maintain consistency
    localStorage.setItem(dataGridId, JSON.stringify(columns));
    return columns;
  } catch (e) {
    return defaultColumns;
  }
};

export const saveDataGridColumns = (dataGridId, defaultColumns, columnUpdated) => {
  try {
    var userColumns = JSON.parse(localStorage.getItem(dataGridId));
    let columns = defaultColumns;
    if (userColumns) {
      columns = userColumns;
    }
    const updatedColumns = mergeColumn(columns, columnUpdated);
    localStorage.setItem(dataGridId, JSON.stringify(updatedColumns));
  } catch (e) {
    console.log(e);
  }
};
